import * as TYPES from './types';

/* eslint-disable no-param-reassign */
export default {

    [TYPES.MAIN_SET_FETCHING](state, fetching) {
        state.fetching = fetching;
    },

    [TYPES.MAIN_SET_MESSAGE](state, message) {
        state.messages[message.type] = message.message;
    },

    [TYPES.AUTH_SET_USER](state, user) {
        state.auth.user = user;
    },

    [TYPES.AUTH_SET_TOKEN](state, token) {
        state.auth.token = token;
    },

    [TYPES.AUTH_SET_REFRESH_TOKEN](state, token) {
        state.auth.refresh_token = token;
    },

    [TYPES.AUTH_SET_TOKEN_EXPIRATION](state, token) {
        state.auth.token_expiration = token;
    },

    [TYPES.AUTH_SET_USER_ABILITIES](state, abilities) {
        state.auth.abilities = abilities;
    },

    [TYPES.AUTH_SET_PROJECT_ABILITIES](state, abilities) {
        state.auth.project_abilities = abilities;
    },

    [TYPES.AUTH_SET_USER_SETTINGS](state, settings) {
        state.auth.settings = settings;
    },

    [TYPES.MAIN_SET_SIDEBAR_LOGO_URL](state, logoUrl) {
        state.sidebar_logo_url = logoUrl;
    },

    [TYPES.AUTH_SET_USER_VERSION](state, version) {
        state.auth.user_version = version;
    },

    [TYPES.MAIN_SET_IS_GLOBAL_MANAGEMENT_SYSTEM](state, isGlobalManagementSystem) {
        state.is_global_management_system = isGlobalManagementSystem;
    },

    [TYPES.MAIN_SET_HAS_CL_ONLY_FEATURES](state, hasClOnlyFeatures) {
        state.has_cl_only_features = hasClOnlyFeatures;
    },

    [TYPES.MAIN_SET_SYSTEM_LOCALE](state, systemLocale) {
        state.system_locale = systemLocale;
    },

    [TYPES.MAIN_SET_LATEST_SCROLL_TO_COMMENT](state, latestScrollToComment) {
        state.states.latest_scroll_to_comment = latestScrollToComment;
    },

    [TYPES.MAIN_SET_PASSWORD_RESET_ENABLED](state, passwordResetEnabled) {
        state.password_reset_enabled = passwordResetEnabled;
    },

};



// WEBPACK FOOTER //
// ./src/store/mutations.js